export const finiteAmount = (value) => (typeof value === "number" || (typeof value === "string" && value.trim() !== "")) && Number.isFinite(Number(value));

export const comparisonAvailable = (sim) => {
  const c = sim?.confronto;
  return sim?.ok === true && !!c && c.mostrabile !== false && [c.totaleAttuale, c.totaleOfferta, c.risparmio].every(finiteAmount);
};

export const recommendedOffer = (sim) => comparisonAvailable(sim) && Number(sim.confronto.risparmio) > 0 ? sim.offerta?.codice : undefined;

export const isNoSavingsProblem = (problem) => {
  const message = typeof problem === "string" ? problem : problem?.messaggio;
  return problem?.codice === "NESSUN_RISPARMIO" || message?.trim().toLowerCase() === "con la nostra offerta non risparmieresti su questa bolletta.";
};

export function simSavings(sim) {
  if (!comparisonAvailable(sim)) return {};
  const out = {}, current = Number(sim.confronto.totaleAttuale);
  const add = (code, total, saving) => {
    if (!code) return;
    const value = finiteAmount(saving) ? Number(saving) : finiteAmount(total) ? current - Number(total) : null;
    if (value == null || (value <= 0 && sim.mostra_perdita === false)) return;
    out[code] = value;
  };
  add(sim.offerta?.codice, sim.confronto.totaleOfferta, sim.confronto.risparmio);
  (sim.alternative || []).filter((a) => a.confronto?.mostrabile !== false).forEach((a) => add(a.codice || a.offerta?.codice, a.totale ?? a.totaleOfferta ?? a.offerta?.totale, a.risparmio ?? a.confronto?.risparmio));
  return out;
}
